<script setup lang="ts">
    import { InputRow } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    import TaskTemplateTaskForm from './TaskTemplateTaskForm.vue';
    import { useKeepersEmployeeData } from '@/composables/useKeepersEmployeeData';
    import InputError from '@/components/InputError.vue';

    const { keepersEmployees } = useKeepersEmployeeData();

    const props = defineProps<{
        form: any;
    }>();

    const addTask = () => {
        props.form.tasks.push({
            name: '',
            description: '',
            weekdays: [],
            status: 'Open',
            responsible_id: '',
            send_notification: 0,
            notification_recurring_week: 0,
            notification_recurring_even_week: 0,
            notification_recurring_start_of_month: 0,
        });
    };

    const removeTask = (index: number) => {
        props.form.tasks.splice(index, 1);
    };

    defineExpose({
        addTask,
    });
</script>

<template>
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <InputRow
            :form="form"
            name="name"
            label="task-templates.table.name"
        >
            <Input
                id="name"
                v-model="form.name"
                :placeholder="$t('task-templates.table.name')"
            />
        </InputRow>
        <InputRow
            :form="form"
            name="description"
            label="task-templates.table.description"
        >
            <Input
                id="description"
                v-model="form.description"
                :placeholder="$t('task-templates.table.description')"
            />
        </InputRow>
    </div>
    <div class="flex flex-col gap-3">
        <InputError :message="form.errors.tasks" />
        <TaskTemplateTaskForm
            v-for="(task, index) in form.tasks"
            :key="index"
            :form="task"
            :main-form="form"
            :index="index"
            :keepers-employees="keepersEmployees"
            @remove="removeTask"
        />
    </div>
</template>
